import.meta.glob(['../images/**', '../fonts/**']);
import 'bootstrap';

import initIcons from './icons';

const SPA_MODULES = import.meta.glob('./pages/*.js');
const COLLECTION_MODULE = './pages/collection-spa.js';
const EVIDENCE_MODULE = './pages/evidence-spa.js';
const EVIDENCE_HUB_MODULE = './pages/evidence-hub.js';

const collectionPaths = new Set([
  '/collection',
  '/collection-browser',
  '/collection/collection-browser',
]);

const evidenceHubPaths = new Set(['/evidence-hub']);

const evidencePaths = new Set([
  '/evidence-hub/evidence-repository',
  '/evidence-hub/evidence-repository/ncace-publications',
  '/evidence-hub/evidence-repository/general-knowledge-exchange',
  '/evidence-hub/evidence-repository/cultural-knowledge-exchange',
  '/evidence-hub/evidence-repository/knowledge-exchange-and-covid-19',
  '/evidence-hub/evidence-repository/toolkits-and-skills-for-knowledge-exchange',
  '/evidence-hub/evidence-repository/placemaking-and-levelling-out',
  '/evidence-hub/evidence-repository/health-and-wellbeing',
  '/evidence-hub/evidence-repository/technologies-for-social-good',
  '/evidence-hub/evidence-repository/technologies-for-gocial-good',
  '/evidence-hub/evidence-repository/environment-and-climate-emergency',
]);

const normalizePathname = (pathname) => {
  if (typeof pathname !== 'string') {
    return '';
  }

  const trimmed = pathname.trim().toLowerCase();
  const withoutTrailingSlash = trimmed.replace(/\/+$/, '');

  return withoutTrailingSlash || '/';
};

const resolveModulePath = () => {
  const path = normalizePathname(window?.location?.pathname || '');

  if (path.startsWith('/collection/collection-browser')) {
    return COLLECTION_MODULE;
  }

  if (collectionPaths.has(path)) {
    return COLLECTION_MODULE;
  }

  if (evidenceHubPaths.has(path)) {
    return EVIDENCE_HUB_MODULE;
  }

  if (evidencePaths.has(path)) {
    return EVIDENCE_MODULE;
  }

  return null;
};

document.addEventListener('DOMContentLoaded', () => {
  initIcons();

  const pathToModule = resolveModulePath();

  if (!pathToModule) {
    return;
  }

  const loader = SPA_MODULES[pathToModule];

  if (!loader) {
    console.warn('No SPA loader found for path', pathToModule);
    return;
  }

  loader()
    .then((mod) => {
      if (typeof mod.default === 'function') {
        mod.default();
      }
    })
    .catch((error) => {
      console.error('Failed to load SPA module', error);
    });
});
